export default {
  menuOpen: false,
  specificManager: {},
  languages: {},
  countries: {}
}



// WEBPACK FOOTER //
// ./src/store/application/state.js